<template>
    <button class="c-a-hamburger" :class="classes" :aria-label="ariaLabel" :aria-controls="ariaControls">
        <span class="c-a-hamburger__line"></span>
        <span class="c-a-hamburger__line"></span>
        <span class="c-a-hamburger__line"></span>
    </button>
</template>

<script>
    export default {
        props: {
            ariaLabel: String,
            ariaControls: String,
            toggled: Boolean,
            modifiers: String
        },
        computed: {
            classes: function() {
                return this.toggled ? `c-a-hamburger--toggled ${this.modifiers}` : this.modifiers
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomHamburger.vue